import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    uploadProgress: (bytesSent: string, bytesTotal: string) => string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Progress text showing uploaded size out of total (e.g., "1.2 MB of 5.0 MB") */
            uploadProgress: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (bytesSent: string, bytesTotal: string): string => __intl__.intl().formatMessage({ id: "JobSize.uploadProgress?c=1ox2fwwwsk06o", defaultMessage: "{bytesSent} of {bytesTotal}" }, { bytesSent: bytesSent, bytesTotal: bytesTotal }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
